/*
 * MCRO001-F0050 / T-MCRO-050 (design: choreo MCRO001-D004 §4.1.3 unknown-kind rule)
 * Slice 2 of 3 — graceful-degrade fallback renderer.
 *
 * An older client meeting a NEWER annotation kind it has never heard of must never
 * crash or swallow the document. Any node whose `kind` is absent from the render
 * registry renders here as an INERT, PLAIN BORDERED BOX labelled with the raw kind
 * string (and title, if any), showing the body verbatim. No resolve affordance ever —
 * a client cannot meaningfully resolve a box type it does not understand.
 */

import React from 'react';

/**
 * @param {{ node: import('../../lib/annotation/annotationNode').AnnotationNode }} props
 */
export default function UnknownKindBox({ node }) {
  const kind = node && typeof node.kind === 'string' ? node.kind : '';
  const label = node && node.title ? `${kind} — ${node.title}` : kind;
  return (
    <section
      className="annotation-box annotation-box--unknown"
      role="region"
      aria-label={`Unsupported annotation: ${label}`}
      data-annotation-kind={kind}
      style={UNKNOWN_BOX_STYLE}
    >
      <header className="annotation-box__border-label" style={BORDER_LABEL_STYLE}>
        <span className="annotation-box__kind" data-testid="unknown-kind-label">
          {kind}
        </span>
        {node && node.title ? (
          <span className="annotation-box__title"> — {node.title}</span>
        ) : null}
      </header>
      {node && node.body ? (
        <pre className="annotation-box__body" style={BODY_STYLE} data-testid="unknown-kind-body">
          {node.body}
        </pre>
      ) : null}
    </section>
  );
}

// Plain, colour-independent border so the box reads as inert regardless of theme or
// colour vision (no colour-only signalling — the word "Unsupported" and the border
// carry the meaning).
const UNKNOWN_BOX_STYLE = {
  border: '1px dashed currentColor',
  borderRadius: '4px',
  padding: '0.5rem',
  margin: '0.25rem 0',
};
const BORDER_LABEL_STYLE = { fontWeight: 600 };
const BODY_STYLE = { whiteSpace: 'pre-wrap', margin: '0.25rem 0 0', fontFamily: 'inherit' };
